import { forwardRef } from 'react';
import { Button, type ButtonVariant } from './Button';
import type { IconDefinition } from '@vrplatform/icons';
import { EllipsisMenu, EllipsisMenuItem } from '@vrplatform/components-legacy';

type BaseProps = {
  loading?: boolean;
  children?: React.ReactNode;
  variant?: ButtonVariant;
  disabled?: boolean;
};

type MenuItem = {
  label: string;
  icon?: IconDefinition;
  onClick: () => void;
};

type Props = BaseProps &
  (
    | {
        onClick: () => void;
        menuItems?: never;
      }
    | {
        onClick?: never;
        menuItems: MenuItem[];
      }
  );

export const ExportButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      onClick,
      children = 'Export',
      loading,
      variant = 'transparent',
      menuItems,
      disabled,
    },
    ref
  ) => {
    'use memo';

    if (menuItems?.length) {
      return (
        <EllipsisMenu
          disabled={disabled}
          width={'auto'}
          arrowPosition="center"
          target={
            <Button
              variant={variant}
              loading={loading}
              leftIcon={'FileDownloadIcon'}
              disabled={disabled}
            >
              {children}
            </Button>
          }
        >
          {menuItems.map((item) => (
            <EllipsisMenuItem
              key={item.label}
              onClick={item.onClick}
              icon={item.icon}
            >
              {item.label}
            </EllipsisMenuItem>
          ))}
        </EllipsisMenu>
      );
    }

    return (
      <Button
        variant={variant}
        onClick={onClick}
        ref={ref}
        disabled={disabled}
        loading={loading}
        leftIcon={'FileDownloadIcon'}
      >
        {children}
      </Button>
    );
  }
);
